import { render, staticRenderFns } from "./BaseEditDialog.vue?vue&type=template&id=529140ed&"
import script from "./BaseEditDialog.vue?vue&type=script&lang=js&"
export * from "./BaseEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports